












































import { defineComponent, computed, PropType, toRefs } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { CopyLevel } from '@tt4b/ttam-enums';

const name = 'ttam-copy-bread-crumb';
export default defineComponent({
  name,
  components: {},
  props: {
    currentLevel: {
      type: Number as PropType<CopyLevel>,
      default: CopyLevel.ADGROUP,
    },
    copyType: {
      type: String,
      required: true,
    },
    copyNum: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { currentLevel, copyType, copyNum } = toRefs(props);
    const isAdgroupBreadcrumbDisabled = computed(() => [CopyLevel.CAMPAIGN].includes(currentLevel.value));
    const isCreativeBreadcrumbDisabled = computed(() =>
      [CopyLevel.CAMPAIGN, CopyLevel.ADGROUP].includes(currentLevel.value),
    );
    const titleContent = computed(() => {
      switch (copyType.value) {
        case 'adgroup':
          return i18n.t('adgroup_copy_title', { number: copyNum.value });
        case 'creative':
          return i18n.t('module_creative_copy_edit_title_plural', { num: copyNum.value });
        default:
          return '';
      }
    });
    const handleLevelChange = (targetLevel: CopyLevel) => {
      emit('chang-level', currentLevel.value, targetLevel);
    };
    const changeBreadcrumb = level => {
      if (level === CopyLevel.ADGROUP && isAdgroupBreadcrumbDisabled.value) {
        return;
      }
      if (level === CopyLevel.CREATIVE) {
        return;
      }
      handleLevelChange(level);
    };

    return {
      name,
      CopyLevel,
      titleContent,
      isAdgroupBreadcrumbDisabled,
      isCreativeBreadcrumbDisabled,
      changeBreadcrumb,
    };
  },
});
